import { useState } from 'react';
import Icon from './Icon';
import './EtapePlateaux.css';

function fmt$(v) {
  return `${parseFloat(v).toFixed(0)} $`;
}

function ContenuPlateau({ contenu }) {
  if (!contenu || contenu.length === 0) return null;
  return (
    <div className="plateau-contenu-visuel">
      {contenu.map((item, i) => (
        <div key={i} className="plateau-contenu-item">
          <Icon name="fumage" size={12} weight="fill" color="currentColor" />
          <span className="plateau-contenu-label">
            {item.label || `${item.quantite}${item.unite} ${item.produit}`}
          </span>
        </div>
      ))}
    </div>
  );
}

function CardPlateau({ plateau, quantite, onChanger, sidesEvenement = [] }) {
  const [pulse, setPulse] = useState(false);
  const selectionne = quantite > 0;
  const contenu = plateau.contenu
    ? (typeof plateau.contenu === 'string' ? JSON.parse(plateau.contenu) : plateau.contenu)
    : [];
  const sidesRaw = plateau.sides_inclus || plateau.sides || [];
  const sides = sidesRaw.length > 0 ? sidesRaw : sidesEvenement;
  const nbPersonnes = plateau.taille || plateau.nb_personnes || 1;

  function augmenter() {
    onChanger(quantite + 1);
    setPulse(true);
    setTimeout(() => setPulse(false), 400);
  }

  function diminuer() {
    onChanger(Math.max(0, quantite - 1));
  }

  return (
    <div className={[
      'plateau-card',
      selectionne ? 'plateau-selected' : '',
      pulse ? 'plateau-pulse' : '',
    ].join(' ')}>
      <div className="plateau-header">
        <div>
          <div className="plateau-label">{plateau.label}</div>
          {nbPersonnes > 0 && (
            <div className="plateau-taille">
              <Icon name="utilisateur" size={11} weight="regular" color="currentColor" />
              {nbPersonnes === 1 ? '1 personne' : `${nbPersonnes} personnes`}
            </div>
          )}
        </div>
        <div className="plateau-prix">{fmt$(plateau.prix)}</div>
      </div>

      {plateau.description && (
        <div className="plateau-desc">{plateau.description}</div>
      )}

      {contenu.length > 0 && (
        <div className="plateau-contenu-wrap">
          <div className="plateau-divider">Contenu</div>
          <ContenuPlateau contenu={contenu} />
        </div>
      )}

      {sides.length > 0 && (
        <div className="plateau-sides">
          <span className="plateau-sides-sep" />
          <span className="plateau-sides-lbl">Accompagnements</span>
          <span className="plateau-sides-val">{sides.join(' · ')}</span>
        </div>
      )}

      <div className="plateau-qte">
        <button
          className="qte-btn"
          onClick={diminuer}
          disabled={quantite === 0}
          aria-label="Diminuer quantité"
        >
          <span aria-hidden="true">−</span>
        </button>
        <span className="qte-val">{quantite}</span>
        <button
          className="qte-btn qte-btn-plus"
          onClick={augmenter}
          aria-label="Augmenter quantité"
        >
          <span aria-hidden="true">+</span>
        </button>
        {quantite > 0 && (
          <span className="plateau-sous-total">
            {fmt$(plateau.prix * quantite)}
          </span>
        )}
      </div>
    </div>
  );
}

export default function EtapePlateaux({ evenement, selection, onChanger, erreur }) {
  const plateaux = evenement?.plateaux || [];
  const sidesEvenement = (evenement?.sides || [])
    .filter(s => s.actif !== 0)
    .sort((a, b) => a.ordre - b.ordre)
    .map(s => `${s.emoji} ${s.nom}`);
  const totalPersonnes = plateaux.reduce(
    (acc, p) => acc + (selection[p.id] || 0) * (p.taille || p.nb_personnes || 1), 0
  );
  const sousTotal = plateaux.reduce(
    (acc, p) => acc + (selection[p.id] || 0) * p.prix, 0
  );

  return (
    <div className="etape-plateaux">
      <div className="etape-intro">
        <p>Choisissez vos plateaux et les quantités désirées.</p>
      </div>

      {totalPersonnes > 0 && (
        <div className="plateaux-compteur">
          <Icon name="repas" size={15} weight="fill" color="currentColor" />
          Pour <strong>{totalPersonnes}</strong> personne{totalPersonnes > 1 ? 's' : ''}
        </div>
      )}

      <div className="plateaux-grille">
        {plateaux.map(p => (
          <CardPlateau
            key={p.id}
            plateau={p}
            quantite={selection[p.id] || 0}
            onChanger={val => onChanger(p.id, val)}
            sidesEvenement={sidesEvenement}
          />
        ))}
      </div>

      {erreur && (
        <div className="etape-erreur">
          <Icon name="erreur" size={15} weight="fill" color="currentColor" />
          {erreur}
        </div>
      )}

      {sousTotal > 0 && (
        <div className="plateaux-total">
          <div className="total-ligne">
            <span className="total-ligne-label">
              <Icon name="utilisateur" size={13} weight="regular" color="currentColor" />
              Personnes
            </span>
            <span>{totalPersonnes}</span>
          </div>
          <div className="total-ligne total-montant">
            <span>Sous-total plateaux</span>
            <span className="total-gros">{fmt$(sousTotal)}</span>
          </div>
        </div>
      )}
    </div>
  );
}
